import { useTranslation } from 'react-i18next'
import { HeroPage } from '@/components/HeroPage'
import { CompanyHistory } from '@/components/sections/CompanyHistory'
import { ContactCTA } from '@/components/sections/ContactCTA'

export function About() {
  const { t } = useTranslation()

  return (
    <main>
      <HeroPage
        title={t('about.hero.title')}
        subtitle={t('about.hero.subtitle')}
        backgroundImage="/images/general/hero_azienda.jpg"
        breadcrumb={[{ label: t('nav.about') }]}
      />
      <CompanyHistory />
      <ContactCTA />
    </main>
  )
}
